import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import { getUnidades } from "../../../../Base/API/Global/Unidades/UnidadesRequest";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";

import { getEstadosCotizaciones } from "../../../../API/Global/Status/StatusRequests";
import { EditarKnitCost, GuardarKnitCost } from "../../../../API/Ventas/Cotizaciones/CotizacionesRequest";
import { getFabricStyles, getStyleCategory, getYarnTitle } from "../../../../API/Desarrollo/DesarrolloRequest";

const KnitCostCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected  = () => {},
  modo,
  getInfo = () => {},
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [stylesCategory, setStylesCategory] = useState([]);
  const [yarnMin, setYarnMin] = useState([]);
  const [yarnMax, setYarnMax] = useState([]);
  const [yarn, setYarn] = useState([]);
  const [units, setUnits] = useState([]);
  const [fabricStyle, setFabricStyle] = useState([]);


  const initialValues = {
    IdKnitCost: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
    AllYarn: false,
    SinRango: false,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);


  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCotizaciones()
    setEstados(estadosTempo)
    const estadoInicial = modo === "Crear" ? estadosTempo[0]: estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    const stylesTempo = await getStyleCategory()
    setStylesCategory(stylesTempo)

    const yarnTempo = await getYarnTitle()
    setYarnMin(yarnTempo.filter((i) => i?.IdStatus === 3706))
    setYarnMax(yarnTempo.filter((i) => i?.IdStatus === 3706))
    setYarn(yarnTempo.filter((i) => i?.IdStatus === 3706))

    const unitsTempo = await getUnidades()
    setUnits(unitsTempo.filter((i) => [1, 3].includes(i.IdUnit)));

    const fabicTempo = await getFabricStyles()
    setFabricStyle(fabicTempo.filter((i) => i?.IdStatus === 3706))

    const yarnInicialMin = modo === "Crear" ? null : yarnTempo.find((e) => e.IdYarnTitle === selected?.IdMinYarn)
    const yarnInicialMax = modo === "Crear" ? null : yarnTempo.find((e) => e.IdYarnTitle === selected?.IdMaxYarn)
    const yarnInicial = modo === "Crear" ? null : yarnTempo.find((e) => e.IdYarnTitle === selected?.IdYarn)
    const fabricInicial = modo === "Crear" ? null : fabicTempo.find((e) => e.IdFabricStyle === selected?.IdFabricStyle)
    const unitInicial = modo === "Crear" ? null : unitsTempo.find((e) => e.IdUnit === selected?.IdUnit)

    const desc = selected?.Hilo

    setValues({
      ...selected,
      IdKnitCost: selected ? selected?.IdKnitCost : -1,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      MinYarn: yarnInicialMin,
      IdMinYarn: yarnInicialMin?.IdYarnTitle,
      MaxYarn: yarnInicialMax,
      IdMaxYarn: yarnInicialMax?.IdYarnTitle,
      Yarn: yarnInicial,
      IdYarn: yarnInicial?.IdYarnTitle,
      FabricStyle: fabricInicial,
      IdFabricStyle: fabricStyle?.IdFabricStyle,
      UnitName: unitInicial,
      IdUnit: unitInicial?.IdUnit,
      AllYarn: selected?.AllYarn,
      SinRango: selected?.SinRango,
      Description: desc,
    });

    setLoading(false);
  };

  const onHide = () => {
    setDialog(false)
    setSelected(null)
  };

  const verificarInfo = () => {
    let error = {};

    if (modo === "Crear") {
      if (!values.StyleCategory || values.IdStyleCategory) {
        error.IdStyleCategory = true;
        error.error = true;
      }
      if(!values.AllYarn && !values.SinRango){
        if (!values.MinYarn || values.IdMinYarn) {
          error.IdMinYarn = true;
          error.error = true;
        }
        if (!values.MaxYarn || values.IdMaxYarn) {
          error.MaxYarn = true;
          error.error = true;
        }
      }
      if(values?.SinRango){
        if (!values.Yarn || values.IdYarn) {
          error.Yarn = true;
          error.error = true;
        }
      }
      if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
      if (!values.UnitName) {
        error.IdUnit = true;
        error.error = true;
      }
      if (!values.FabricStyle) {
        error.IdFabricStyle = true;
        error.error = true;
      }
    } else {
      if (!values.StyleCategory || values.IdStyleCategory) {
        error.IdStyleCategory = true;
        error.error = true;
      }
      if(!values.AllYarn && !values.SinRango){
        if (!values.MinYarn || !values.IdMinYarn) {
          error.IdMinYarn = true;
          error.error = true;
        }
        if (!values.MaxYarn || !values.IdMaxYarn) {
          error.MaxYarn = true;
          error.error = true;
        }
      }
      if(values?.SinRango){
        if (!values.Yarn || !values.IdYarn) {
          error.Yarn = true;
          error.error = true;
        }
      }
      if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
      if (!values.UnitName || !values.IdUnit) {
        error.IdUnit = true;
        error.error = true;
      }
      if (!values.FabricStyle || values.IdFabricStyle) {
        error.IdFabricStyle = true;
        error.error = true;
      }
    }

    if (!values.Price) {
      error.Price = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const Datos = {
        IdKnitCost: values?.IdKnitCost,
        IdStylesCategory:values?.StyleCategory?.IdStyleCategory || values?.IdStylesCategory,
        IdYarn: values?.Yarn?.IdYarnTitle || values?.IdYarn,
        Yarn: values?.Yarn?.YarnInt || values?.Yarn,
        IdMinYarn: values?.MinYarn?.IdYarnTitle || values?.IdMinYarn,
        MinYarn: values?.MinYarn?.YarnInt || values?.MinYarn,
        IdMaxYarn: values?.MaxYarn?.IdYarnTitle || values?.IdMaxYarn,
        MaxYarn: values?.MaxYarn?.YarnInt || values?.YarnInt,
        Price: values?.Price,
        IdUnit: values?.UnitName?.IdUnit || values?.IdUnit,
        IdStatus: values?.Estado?.IdStatus,
        IdFabricStyle:values?.FabricStyle?.IdFabricStyle || values?.IdFabricStyle,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
        AllYarn: values?.AllYarn,
        SinRango: values?.SinRango,
      };

      if(!Datos?.SinRango){
        if(Datos?.MinYarn >= Datos?.MaxYarn){
          toastShow(toast, "error", "Datos Agregados", 'El Min Yarn debe ser menor al Max Yarn');
          return;
        }
      }

      setLoading(true);
      if (values?.IdKnitCost > 0) {
        const respuesta = await EditarKnitCost(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarKnitCost(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  const filtrarHilaza = async (IdStyle) => {
    const dataYarn = await getYarnTitle()
    let filtro = dataYarn.filter((i) => i.IdStyleCategory === IdStyle);
    if(filtro.length > 0){
      setYarnMin(filtro)
    }else{
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con Hilaza disponibles"
      );
      setYarnMin([])
    }
  }

  const filtrarTejido = async (IdStyle) => {
    const dataFabric = await getFabricStyles()
    let filtro = dataFabric.filter((i) => i.IdStylesCategory === IdStyle);
    if(filtro.length > 0){
      setFabricStyle(filtro)
    }else{
      toastShow(
        toast,
        "warn",
        "Seleccione otro estilo de categoría",
        "La Categoría seleccionada no cuenta con tejidos disponibles"
      );
      setYarnMin([])
    }
  }

  useEffect(() => {
    let IdStyle = values?.StyleCategory?.IdStyleCategory ? values?.StyleCategory?.IdStyleCategory : values?.IdStylesCategory
    if (IdStyle) {
      filtrarHilaza(IdStyle); 
      filtrarTejido(IdStyle); 
      if(values?.StyleCategory?.IdStyleCategory){
        if(!(values?.StyleCategory?.IdStyleCategory === values?.IdStylesCategory)){
          setValues({
            ...values,
            IdYarnTitle: null,
            Title: "", 
            IdFabricStyle: null,
            FabricStyle: "", 
          });
        }
      }else{
        if(!values?.StyleCategory){
          setValues({
            ...values,
            IdYarnTitle: null,
            Title: "", 
            IdFabricStyle: null,
            FabricStyle: "", 
          });
        }
      }
    } else {
      setYarnMin([]); 
      setValues({
        ...values,
        IdYarnTitle: null,
        Title: "",
        IdFabricStyle: null,
        FabricStyle: "", 
      });
    }
  }, [values?.StyleCategory, values?.IdStylesCategory]);

  useEffect(() => {
    let IdStyleCategory = values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory;
    if (values?.MinYarn?.IdYarnTitle && values?.MaxYarn?.IdYarnTitle && IdStyleCategory) {
      if(IdStyleCategory === 19){
        setValues({
          ...values,
          Description: values?.MinYarn?.YarnInt + '`D' + '~' + values?.MaxYarn?.YarnInt + '`D'
        })
      }else{
        setValues({
          ...values,
          Description: values?.MinYarn?.YarnInt + '`S' + '~' + values?.MaxYarn?.YarnInt + '`S'
        })
      }
    }else{
      if(modo === "Crear"){
        setValues({
          ...values,
          Description: '',
        })
      }
    }
  }, [values?.MinYarn, values?.MaxYarn, values?.StyleCategory?.IdStyleCategory, values?.IdStyleCategory]);

  useEffect(() => {
    let IdStyleCategory = values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory;
    if (values?.Yarn && IdStyleCategory) {
      if(IdStyleCategory === 19){
        setValues({
          ...values,
          Description: values?.Yarn?.YarnInt + '`D'
        })
      }else{
        setValues({
          ...values,
          Description: values?.Yarn?.YarnInt + '`S'
        })
      }
    }else{
      if(modo === "Crear"){
        setValues({
          ...values,
          Description: '',
        })
      }
    }
  }, [values?.Yarn, values?.StyleCategory?.IdStyleCategory, values?.IdStyleCategory]);

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "agregarCostoT", config.language)}` : `${getLabel(baseLang, "editarCostoT", config.language)}`;

  return (
    <div>
      <Dialog
        visible={dialog}
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
      <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-5">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StyleCategory"}
                    value={values.StyleCategory}
                    items={stylesCategory}
                    field={"StyleCategory"}
                    label={getLabel(baseLang, "estilo", config.language)}
                    handleInputChange={(e) => {
                      handleInputChange(e);
                      setValues(prevValues => ({
                        ...prevValues,
                        MinYarn: null,
                        MaxYarn: null,
                      }));
                    }}
                    className={error.IdStyleCategory ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 mx-4 mt-3">
                <div className="d-flex gap-4">
                  <div className="d-flex">                      
                    <Checkbox
                      inputId="AllYarn"
                      value="AllYarn"
                      onChange={(e) => {
                        const checked = e.checked;
                        setValues((prevValues) => ({
                          ...prevValues,
                          AllYarn: checked,
                          MinYarn: checked ? null : prevValues.MinYarn,
                          MaxYarn: checked ? null : prevValues.MaxYarn,
                          SinRango: checked ? null : prevValues.SinRango,
                          Description: checked ? "" : prevValues.Description,
                          IdMinYarn: checked ? null : prevValues.IdMinYarn,
                          IdMaxYarn: checked ? null : prevValues.IdMaxYarn,
                          IdYarn: checked ? null : prevValues.IdYarn,
                          Yarn: checked ? null : prevValues.Yarn,
                        }));
                      }}
                      checked={values?.AllYarn}
                    />
                    <label htmlFor="AllYarn" className="p-checkbox-label mx-2">
                      All Yarn
                    </label>
                  </div>

                  <div className="d-flex">
                    <Checkbox
                      inputId="SinRango"
                      value="SinRango"
                      disabled={values?.AllYarn}
                      onChange={(e) => {
                        const checked = e.checked;
                        setValues((prevValues) => ({
                          ...prevValues,
                          SinRango: checked,
                          MinYarn: checked ? null : prevValues.MinYarn,
                          MaxYarn: checked ? null : prevValues.MaxYarn,
                          Description: checked ? "" : prevValues.Description,
                        }));
                      }}
                      checked={values?.SinRango}
                    />
                    <label htmlFor="SinRango" className="p-checkbox-label mx-2">
                      {getLabel(baseLang, "SinRango", config.language)}
                    </label>
                  </div>
                </div>
              </div>
            </div>


            {!values?.AllYarn && !values?.SinRango && (

              <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2 d-flex gap-4">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"MinYarn"}
                      value={values.MinYarn}
                      items={yarnMin}
                      field={"Title"}
                      label={getLabel(baseLang, "MinYarn", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.IdMinYarn ? "p-invalid" : ""}
                      filterValue={values?.StyleCategory}
                      itemsFilter={(e) => {
                        let Id =  values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory
                        let filtro = yarnMin.filter((s) => s.IdStyleCategory === Id);      
                        let filtro2 = values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory


                        if(filtro?.length === 0 && filtro2){
                          toastShow(
                            toast,
                            "warn",
                            "Seleccione otra Categoría",
                            "La Categoría seleccionada no cuenta con Hilos disponibles"
                          );
                        }
                        return filtro
                      }}
                    />
                  </span>

                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"MaxYarn"}
                      value={values.MaxYarn}
                      items={yarnMax}
                      field={"Title"}
                      label={getLabel(baseLang, "MaxYarn", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.MaxYarn ? "p-invalid" : ""}
                      filterValue={values?.StyleCategory}
                      itemsFilter={(e) => {
                        let Id =  values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory
                        let filtro = yarnMax.filter((s) => s.IdStyleCategory === Id);      
                        let filtro2 = values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory


    
                        if(filtro?.length === 0 && filtro2){
                          toastShow(
                            toast,
                            "warn",
                            "Seleccione otra Categoría",
                            "La Categoría seleccionada no cuenta con Hilos disponibles"
                          );
                        }
                        return filtro
                      }}
                    />
                  </span>
                </div>
        
                <div className="field col-6 me-2  mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="Description"
                      value={values.Description}
                      disabled
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      className={error.Description ? "p-invalid" : ""}
                    />
                    <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                  </span>
                </div>
              </div>
            )}

            {values?.SinRango && (

              <div className="modal__input-contenedor">
                <div className="field col-6 me-2  mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Yarn"}
                      value={values.Yarn}
                      items={yarn}
                      field={"Title"}
                      label={getLabel(baseLang, "Yarn", config.language)}
                      handleInputChange={handleInputChange}
                      className={error.Yarn ? "p-invalid" : ""}
                      filterValue={values?.StyleCategory}
                      itemsFilter={(e) => {
                        let Id =  values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory
                        let filtro = yarn.filter((s) => s.IdStyleCategory === Id);      
                        let filtro2 = values.StyleCategory?.IdStyleCategory || values?.IdStylesCategory


                        if(filtro?.length === 0 && filtro2){
                          toastShow(
                            toast,
                            "warn",
                            "Seleccione otra Categoría",
                            "La Categoría seleccionada no cuenta con Hilos disponibles"
                          );
                        }
                        return filtro
                      }}
                    />
                  </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="Description"
                      value={values.Description}
                      disabled
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      className={error.Description ? "p-invalid" : ""}
                    />
                    <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                  </span>
                </div>
              </div>
            )}

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"FabricStyle"}
                    value={values.FabricStyle}
                    items={fabricStyle}
                    field={"FabricStyle"}
                    label={getLabel(baseLang, "fabric", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdFabricStyle ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"UnitName"}
                    value={values.UnitName}
                    items={units}
                    field={"UnitName"}
                    label={getLabel(baseLang, "unidad", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdUnit ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            
            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={getLabel(baseLang, "estado", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="Price"
                    value={values.Price}
                    onChange={handleInputChange}
                    minFractionDigits={2}
                    style={{ width: "100%" }}
                    className={error.Price ? "p-invalid" : ""}
                  />
                  <label htmlFor="Price">{getLabel(baseLang, "precio", config.language)}</label>
                </span>
              </div>

            </div>


          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default KnitCostCRUD;
